var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[(_vm.user)?[_c('Word',{attrs:{"wordRef":_vm.wordRef}})]:[_c('button',{on:{"click":_vm.signInWithGoogle}},[_vm._v("Sign in with Google")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }